import { BaseModel, RecursivePartial, SM } from '@models/base';
import { PersonType } from './person-type';

export class PersonOrgDetails extends BaseModel {
    id!: string;
    isOwner?: boolean;
    fired?: boolean;
    roleIds: string[] = [];
    groupIds: string[] = [];
    projectIds: string[] = [];
    personType!: PersonType;
    departmentId!: string;
    privs?: string[];
    options?: SM<any>;

    constructor(json?: RecursivePartial<PersonOrgDetails>) {
        super(json);
        this.parsePersonOrgDetails(json || {});
    }

    parse(json: RecursivePartial<PersonOrgDetails>): PersonOrgDetails {
        super.parse(json);
        this.parsePersonOrgDetails(json);
        return this;
    }

    private parsePersonOrgDetails(json: RecursivePartial<PersonOrgDetails>): void {
        PersonOrgDetails.assignFields<PersonOrgDetails>(this, json, [
            'id',
            'isOwner',
            'fired',
            'roleIds',
            'groupIds',
            'projectIds',
            'departmentId',
            'privs',
            'options'
        ]);
        if (!this.projectIds?.length && (json as any).projects && Array.isArray((json as any).projects)) {
            this.projectIds = ((json as any).projects as any[]).map(p => p.id);
        }
    }
}
